module.exports = __webpack_public_path__ + "static/media/meet-jp-thumb.b3d0156d.jpeg";